
import { Vue } from "vue-class-component";

export default class Ellipsis extends Vue {}
